// extracted by mini-css-extract-plugin
export default {"profileImage":"styles_profileImage__w2Ohn","channelIcon":"styles_channelIcon__IdyPO"};